import { Grid, Tooltip } from '@material-ui/core';
import { Cake, Mail, Phone, Send } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import { checkAffiliateStudentOrganization } from '@webapps/business';
import {
  Button,
  Modal as ModalComp,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ageCalculator } from '@webapps/utils';
import MessageBox from 'components/MessageBox';
import Modal, { default as ModalStep } from 'components/Modal';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import AffiliationSendBusiness from './AffiliationBusiness';
import AffiliationSendSchool from './AffiliationSchool';
import Information from 'components/Icons/Information';
import { formatPhoneNumber } from 'react-phone-number-input';

const Contact = ({ info, shareClassroom }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [showTooltip, setShowTooltip] = useState(false);

  const LightTooltip = withStyles(({ shadows }) => ({
    tooltip: {
      backgroundColor: '#5D75A8',
      color: '#FFF',
      boxShadow: shadows[1],
      '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
      fontWeight: 600,
    },
  }))(Tooltip);

  const { idUser, profile } = useAuth();
  const [stepAffilation, setStepAffiliation] = useState(1);
  const { addToast } = useToast();
  const [addModalAffiliationBusiness, setAddModalAffiliationBusiness] =
    useState(false);
  const [addModalAffiliationSchool, setAddModalAffiliationSchool] =
    useState(false);
  const [openMessageBox, setOpenMessageBox] = useState(false);

  const { data: checkAffilate, refetch } = useQuery(
    checkAffiliateStudentOrganization,
    {
      key: ['checkAffiliate', info?.id],
      variables: { organizationId: idUser, studentId: info?.id },
    }
  );

  return (
    <div className={cx(classes.container)}>
      <div className={cx(classes.title, global.title)}>
        <FormattedMessage id="student.profil.contact.title" />
      </div>
      {!info?.email?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <div
          className={css({
            width: '100%',
            marginTop: spacing(1),
            marginBottom: spacing(2),
          })}
        >
          <div className={cx(classes.address, global.infoText)}>
            <div style={{ display: 'flex', alignItems: 'left' }}>
              <Cake className={global.infoIcon} />
              <div>Age :</div>
            </div>
            <div className={classes.phone}>
              {info?.birthDate
                ? `${ageCalculator(info?.birthDate)} ans`
                : 'Non renseigné'}
            </div>
          </div>
          <div className={cx(classes.address, global.infoText)}>
            <div style={{ display: 'flex' }}>
              <Mail className={global.infoIcon} />
              <div>Adresse e-mail :</div>
            </div>
            <a
              className={classes.phone}
              href={`mailto:${info?.email}`}
              rel="noreferrer"
              target="_blank"
            >
              {info?.email}
            </a>
          </div>
          <div className={cx(classes.address, global.infoText)}>
            <div style={{ display: 'flex' }}>
              <Phone className={global.infoIcon} />
              <div>Numéro de téléphone :</div>
            </div>
            <a className={classes.phone}>
              {info?.phone ? formatPhoneNumber(info?.phone) : 'Non renseigné'}
            </a>
          </div>
        </div>
      )}
      <Grid className={classes.ButtonContainer} container>
        <Grid item xs={4} xl={3}>
          {shareClassroom ? (
            <>
            <LightTooltip title="Inscrivez-vous pour profiter de toutes les fonctionnalités de Linkpick" placement="top">
              <div>
                <Button
                  className={css({ backgroundColor: 'white' })}
                  color="primary"
                  disabled
                  fullWidth
                  onClick={() => setOpenMessageBox(true)}
                  variant="outlined"
                >
                  <Send style={{ fontSize: '15.0px', marginRight: spacing(0.5) }} />{' '}
                  Contacter
                </Button>
              </div>
            </LightTooltip></> ) : (
            <Button
            className={css({ backgroundColor: 'white' })}
              color="primary"
              fullWidth
              onClick={() => setOpenMessageBox(true)}
              variant="outlined"
            >
              <Send style={{ fontSize: '15.0px', marginRight: spacing(0.5) }} />{' '}
              Contacter
            </Button>
            )}
        </Grid>
        <Grid item xs={7} xl={6} className={classes.buttonSendAff}>
          {!checkAffilate ? (
            <>
             {
              shareClassroom ? (
              <LightTooltip title="Inscrivez-vous pour profiter de toutes les fonctionnalités de Linkpick" placement="top">
                <div>
                  <Button
                    className={css({ boxShadow: 'none' })}
                    color="primary"
                    fullWidth
                    disabled
                    border
                    onClick={() => {
                      profile === 'BUSINESS'
                        ? setAddModalAffiliationBusiness(true)
                        : setAddModalAffiliationSchool(true);
                    }}
                    variant="contained"
                  >
                    Envoyer une demande d'affiliation
                  </Button>
                </div>
              </LightTooltip> ) : (
                <Button
                className={css({ boxShadow: 'none' })}
                color="primary"
                fullWidth
                border
                onClick={() => {
                  profile === 'BUSINESS'
                    ? setAddModalAffiliationBusiness(true)
                    : setAddModalAffiliationSchool(true);
                }}
                variant="contained"
              >
                Envoyer une demande d'affiliation
              </Button> )}
            </>
          ) : (
            <Button
            className={css({ boxShadow: 'none' })}
              disabled
              color="primary"
              fullWidth
              variant="contained"
            >
              Demande envoyée
            </Button>
          )}
        </Grid>
        <Grid xs={1}>
          <LightTooltip
              open={showTooltip}
              onOpen={() => setShowTooltip(true)}
              onClose={() => setShowTooltip(false)}
              placement="top-start"
              title={`Amorcez des affiliations afin de récupérer les documents de vos futur(e)s apprenants.`}
            >
              <div
                onClick={() => setShowTooltip(!showTooltip)}
                style={{
                  borderRadius: '20px',
                  border: '1px solid #C0D9FF',
                  backgroundColor: '#F3F7FF',
                  width: '30px',
                  display: 'flex',
                  justifyContent: 'center',
                  height: '30px',
                  alignItems: 'center',
                  cursor: 'pointer',
                  color: '#5A6DA1',
                  '@media only screen and (max-width:1920px)': {fontSize: '15.00px'}, '@media only screen and (max-width:1600px)': {fontSize: '14.00px'},
                  fontFamily: 'Montserrat',
                  fontWeight: 600,
                  marginLeft: spacing(1),
                }}
              >
                ?
              </div>
            </LightTooltip>
        </Grid>
      </Grid>
      <ModalComp
        onCancel={() => setOpenMessageBox(false)}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({display: 'flex', flexDirection: 'row'})}>
          <span>
          <Information className={css({color:'#0060F9', height: 20, width: 20, marginRight: 10})}/>
          </span>
          <div className={css({fontSize: 14, color:'rgba(0, 0, 0, 0.87)'})}>
          Envoyez un message aux candidats et gardez contact dans votre
          messagerie
          </div>
        </div>
        <MessageBox id={info?.id} onCancel={() => setOpenMessageBox(false)} />
      </ModalComp>
      <ModalStep
        nbStep={2}
        onCancel={() => setAddModalAffiliationBusiness(false)}
        open={addModalAffiliationBusiness}
        step={stepAffilation}
        title="Formulaire d’affiliation"
        // subTitle="Cette affiliation vous permettra d’ajouter l’apprenant à vos affiliations. Ainsi vous pourrez lui demander des documents et finaliser l’affiliation en acceptant de l’intégrer dans une équipe."
      >
        
                 <div className={css({display: 'flex', flexDirection: 'row', marginTop: 16})}>
          <span>
          <Information className={css({color:'#0060F9', height: 20, width: 20, marginRight: 10})}/>
          </span>
          <div className={css({fontSize: 14, color:'rgba(0, 0, 0, 0.87)'})}>
          Cette affiliation vous permettra d’ajouter l’apprenant à vos affiliations. Ainsi vous pourrez lui demander des documents et finaliser l’affiliation en acceptant de l’intégrer dans une équipe.
          </div>
        </div>
        <AffiliationSendBusiness
          applicant={info}
          offer={info}
          onChangeStepAffiliation={setStepAffiliation}
          onClose={() => setAddModalAffiliationBusiness(false)}
          refetch={refetch}
        />
      </ModalStep>
      <ModalStep
        nbStep={2}
        onCancel={() => setAddModalAffiliationSchool(false)}
        open={addModalAffiliationSchool}
        step={stepAffilation}
        // subTitle="Affiliez un candidat et demandez des documents"
        title="Ajouter un candidat dans vos affilliations"
      >
        <AffiliationSendSchool
          applicant={info}
          onChangeStepAffiliation={setStepAffiliation}
          onClose={() => setAddModalAffiliationSchool(false)}
          refetch={refetch}
        />
      </ModalStep>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2.5),
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    fontFamily: 'Montserrat',
    paddingLeft: spacing(1),
    marginBottom: '10px',
  },
  infoContainer: {
    display: 'flex',
  },
  infotitle: {
    fontWeight: 600,
    marginLeft: spacing(1),
  },
  address: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: spacing(0.5),
    '@media (max-width: 430px)': {
      flexDirection: 'column',
    },
  },
  phone: {
    color: '#152652',
    marginLeft: spacing(1),
    textDecoration: 'none',
    '@media (max-width: 430px)': {
      marginLeft: spacing(0),
    },
  },
  gridBtn2: {
    '@media (max-width: 839px)': {
      marginTop: spacing(1),
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  ButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 839px)': {
      justifyContent: 'space-between',
    },
    '@media (min-width: 840px) and (max-width: 1024px)': {
      justifyContent: 'start',
    },
  },
  buttonSendAff: {
    display: 'flex',
    alignItems: 'center',
    '& button': {
      marginLeft: spacing(2),
    },
  },
});

Contact.propTypes = {
  info: PropTypes.object,
};

export default Contact;
